// Badge (drawing v2.6, screen 2, row Badge): 22 tall, a pill, 11.5px bold.
// Not interactive; at most one per row, and only where the row differs from
// its neighbors. The tone carries the standard's status and workflow colors;
// never color alone, so the badge always has a word.

import type { ReactNode } from "react";
import { cx } from "./cx";

export type BadgeTone = "neutral" | "info" | "good" | "warn" | "bad" | "opp" | "proc" | "care";

export function Badge({ tone = "neutral", children, className, title }: { tone?: BadgeTone; children: ReactNode; className?: string; title?: string }) {
  return (
    <span className={cx("pg-bdg", tone !== "neutral" && `pg-bdg--${tone}`, className)} title={title}>
      {children}
    </span>
  );
}
